/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  ChangePermissionsRequest,
  CompressFilesRequest,
  CreateFolderRequest,
  DeleteFileRequest,
  DownloadSiteFileParams,
  Error,
  ExtractFileRequest,
  ListFileManagerFilesResponse,
  ListFilesResponse,
  ListSiteFileManagerFilesParams,
  ListSiteFilesDeprecatedParams,
  PathResponse,
  SaveFileRequest,
  SiteID,
  SuccessResponse,
  UploadFileRequest,
  ViewFileResponse,
  ViewSiteFileParams,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Lists files and folders under a path relative to the site document root, with pagination, search, and sorting. Returns name, type, size, permissions, and timestamps. Preferred over the deprecated /files listing endpoint.
 * @summary Browse site files
 */
export const listSiteFileManagerFiles = (
  id: number,
  params: ListSiteFileManagerFilesParams,
  signal?: AbortSignal
) => {
  return customFetch<ListFileManagerFilesResponse>({
    url: `/v1/sites/${id}/file_manager/files`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteFileManagerFilesQueryKey = (
  id?: number,
  params?: ListSiteFileManagerFilesParams
) => {
  return [`/v1/sites/${id}/file_manager/files`, ...(params ? [params] : [])] as const;
};

export const getListSiteFileManagerFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFileManagerFilesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFileManagerFiles>>> = ({
    signal,
  }) => listSiteFileManagerFiles(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/file_manager/files`,
      operationId: 'app.controllers.files_controller.list_site_file_manager_files',
      operationName: 'listSiteFileManagerFiles',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFileManagerFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFileManagerFiles>>
>;
export type ListSiteFileManagerFilesQueryError = Error;

export function useListSiteFileManagerFiles<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
          TError,
          Awaited<ReturnType<typeof listSiteFileManagerFiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFileManagerFiles<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
          TError,
          Awaited<ReturnType<typeof listSiteFileManagerFiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFileManagerFiles<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Browse site files
 */

export function useListSiteFileManagerFiles<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFileManagerFilesQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteFileManagerFilesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFileManagerFilesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFileManagerFiles>>> = ({
    signal,
  }) => listSiteFileManagerFiles(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/file_manager/files`,
      operationId: 'app.controllers.files_controller.list_site_file_manager_files',
      operationName: 'listSiteFileManagerFiles',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFileManagerFilesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFileManagerFiles>>
>;
export type ListSiteFileManagerFilesSuspenseQueryError = Error;

export function useListSiteFileManagerFilesSuspense<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFileManagerFilesSuspense<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFileManagerFilesSuspense<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Browse site files
 */

export function useListSiteFileManagerFilesSuspense<
  TData = Awaited<ReturnType<typeof listSiteFileManagerFiles>>,
  TError = Error,
>(
  id: number,
  params: ListSiteFileManagerFilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFileManagerFiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFileManagerFilesSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Legacy endpoint that lists files and folders for a path without pagination. Use GET /sites/{id}/file_manager/files instead for paginated, sortable results.
 * @summary [Deprecated] List site files
 */
export const listSiteFilesDeprecated = (
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<ListFilesResponse>({
    url: `/v1/sites/${id}/files`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteFilesDeprecatedQueryKey = (
  id?: SiteID,
  params?: ListSiteFilesDeprecatedParams
) => {
  return [`/v1/sites/${id}/files`, ...(params ? [params] : [])] as const;
};

export const getListSiteFilesDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFilesDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFilesDeprecated>>> = ({
    signal,
  }) => listSiteFilesDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/files`,
      operationId: 'app.controllers.files_controller.list_site_files_deprecated',
      operationName: 'listSiteFilesDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFilesDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFilesDeprecated>>
>;
export type ListSiteFilesDeprecatedQueryError = Error;

export function useListSiteFilesDeprecated<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteFilesDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
          TError,
          Awaited<ReturnType<typeof listSiteFilesDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFilesDeprecated<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
          TError,
          Awaited<ReturnType<typeof listSiteFilesDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFilesDeprecated<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] List site files
 */

export function useListSiteFilesDeprecated<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFilesDeprecatedQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteFilesDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFilesDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFilesDeprecated>>> = ({
    signal,
  }) => listSiteFilesDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/files`,
      operationId: 'app.controllers.files_controller.list_site_files_deprecated',
      operationName: 'listSiteFilesDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFilesDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFilesDeprecated>>
>;
export type ListSiteFilesDeprecatedSuspenseQueryError = Error;

export function useListSiteFilesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteFilesDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFilesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFilesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] List site files
 */

export function useListSiteFilesDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof listSiteFilesDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFilesDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFilesDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFilesDeprecatedSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new file at the specified path with text or base64-encoded binary content. Request body must be under 20 MB; use FTP for larger uploads. Returns the file path on success.
 * @summary Upload a new file
 */
export const createSiteFile = (
  id: SiteID,
  uploadFileRequest: UploadFileRequest,
  signal?: AbortSignal
) => {
  return customFetch<PathResponse>({
    url: `/v1/sites/${id}/files`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: uploadFileRequest,
    signal,
  });
};

export const getCreateSiteFileMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteFile>>,
    TError,
    { id: SiteID; data: UploadFileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteFile>>,
  TError,
  { id: SiteID; data: UploadFileRequest },
  TContext
> => {
  const mutationKey = ['createSiteFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteFile>>,
    { id: SiteID; data: UploadFileRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteFile(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/files` },
    {
      operationId: 'app.controllers.files_controller.create_site_file',
      operationName: 'createSiteFile',
    }
  );

  return customOptions;
};

export type CreateSiteFileMutationResult = NonNullable<Awaited<ReturnType<typeof createSiteFile>>>;
export type CreateSiteFileMutationBody = UploadFileRequest;
export type CreateSiteFileMutationError = Error;

/**
 * @summary Upload a new file
 */
export const useCreateSiteFile = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteFile>>,
      TError,
      { id: SiteID; data: UploadFileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteFile>>,
  TError,
  { id: SiteID; data: UploadFileRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Overwrites the contents of an existing file at the given path. Useful for quick code or config edits from the API. Returns the updated file path.
 * @summary Edit an existing file
 */
export const updateSiteFile = (id: SiteID, saveFileRequest: SaveFileRequest) => {
  return customFetch<PathResponse>({
    url: `/v1/sites/${id}/files`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: saveFileRequest,
  });
};

export const getUpdateSiteFileMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSiteFile>>,
    TError,
    { id: SiteID; data: SaveFileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSiteFile>>,
  TError,
  { id: SiteID; data: SaveFileRequest },
  TContext
> => {
  const mutationKey = ['updateSiteFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSiteFile>>,
    { id: SiteID; data: SaveFileRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateSiteFile(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/files` },
    {
      operationId: 'app.controllers.files_controller.update_site_file',
      operationName: 'updateSiteFile',
    }
  );

  return customOptions;
};

export type UpdateSiteFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateSiteFile>>>;
export type UpdateSiteFileMutationBody = SaveFileRequest;
export type UpdateSiteFileMutationError = Error;

/**
 * @summary Edit an existing file
 */
export const useUpdateSiteFile = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSiteFile>>,
      TError,
      { id: SiteID; data: SaveFileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSiteFile>>,
  TError,
  { id: SiteID; data: SaveFileRequest },
  TContext
> => {
  const mutationOptions = getUpdateSiteFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Permanently removes the file or directory at the specified path from the site. This cannot be undone without restoring from a backup.
 * @summary Delete a file or folder
 */
export const deleteSiteFile = (id: SiteID, deleteFileRequest: DeleteFileRequest) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/files`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteFileRequest,
  });
};

export const getDeleteSiteFileMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteFile>>,
    TError,
    { id: SiteID; data: DeleteFileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteFile>>,
  TError,
  { id: SiteID; data: DeleteFileRequest },
  TContext
> => {
  const mutationKey = ['deleteSiteFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteFile>>,
    { id: SiteID; data: DeleteFileRequest }
  > = props => {
    const { id, data } = props ?? {};

    return deleteSiteFile(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/files` },
    {
      operationId: 'app.controllers.files_controller.delete_site_file',
      operationName: 'deleteSiteFile',
    }
  );

  return customOptions;
};

export type DeleteSiteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSiteFile>>>;
export type DeleteSiteFileMutationBody = DeleteFileRequest;
export type DeleteSiteFileMutationError = Error;

/**
 * @summary Delete a file or folder
 */
export const useDeleteSiteFile = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteFile>>,
      TError,
      { id: SiteID; data: DeleteFileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteFile>>,
  TError,
  { id: SiteID; data: DeleteFileRequest },
  TContext
> => {
  const mutationOptions = getDeleteSiteFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates Unix file permissions (for example, 0644 or 0755) on a file or directory. Often needed when scripts or uploads fail due to permission errors.
 * @summary Change file permissions
 */
export const chmodSiteFile = (id: SiteID, changePermissionsRequest: ChangePermissionsRequest) => {
  return customFetch<PathResponse>({
    url: `/v1/sites/${id}/files/chmod`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: changePermissionsRequest,
  });
};

export const getChmodSiteFileMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chmodSiteFile>>,
    TError,
    { id: SiteID; data: ChangePermissionsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chmodSiteFile>>,
  TError,
  { id: SiteID; data: ChangePermissionsRequest },
  TContext
> => {
  const mutationKey = ['chmodSiteFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chmodSiteFile>>,
    { id: SiteID; data: ChangePermissionsRequest }
  > = props => {
    const { id, data } = props ?? {};

    return chmodSiteFile(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/files/chmod` },
    {
      operationId: 'app.controllers.files_controller.chmod_site_file',
      operationName: 'chmodSiteFile',
    }
  );

  return customOptions;
};

export type ChmodSiteFileMutationResult = NonNullable<Awaited<ReturnType<typeof chmodSiteFile>>>;
export type ChmodSiteFileMutationBody = ChangePermissionsRequest;
export type ChmodSiteFileMutationError = Error;

/**
 * @summary Change file permissions
 */
export const useChmodSiteFile = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chmodSiteFile>>,
      TError,
      { id: SiteID; data: ChangePermissionsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chmodSiteFile>>,
  TError,
  { id: SiteID; data: ChangePermissionsRequest },
  TContext
> => {
  const mutationOptions = getChmodSiteFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Bundles one or more files or folders into a single archive (zip, tar, tar.gz, tar.bz2, bz2, or gz). Returns the path to the created archive.
 * @summary Create a compressed archive
 */
export const createSiteFilesArchive = (
  id: SiteID,
  compressFilesRequest: CompressFilesRequest,
  signal?: AbortSignal
) => {
  return customFetch<PathResponse>({
    url: `/v1/sites/${id}/files/compress`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: compressFilesRequest,
    signal,
  });
};

export const getCreateSiteFilesArchiveMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteFilesArchive>>,
    TError,
    { id: SiteID; data: CompressFilesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteFilesArchive>>,
  TError,
  { id: SiteID; data: CompressFilesRequest },
  TContext
> => {
  const mutationKey = ['createSiteFilesArchive'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteFilesArchive>>,
    { id: SiteID; data: CompressFilesRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteFilesArchive(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/files/compress` },
    {
      operationId: 'app.controllers.files_controller.create_site_files_archive',
      operationName: 'createSiteFilesArchive',
    }
  );

  return customOptions;
};

export type CreateSiteFilesArchiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteFilesArchive>>
>;
export type CreateSiteFilesArchiveMutationBody = CompressFilesRequest;
export type CreateSiteFilesArchiveMutationError = Error;

/**
 * @summary Create a compressed archive
 */
export const useCreateSiteFilesArchive = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteFilesArchive>>,
      TError,
      { id: SiteID; data: CompressFilesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteFilesArchive>>,
  TError,
  { id: SiteID; data: CompressFilesRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteFilesArchiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Streams the raw file to the client with appropriate content headers. Specify filename and optional directory relative to the site root.
 * @summary Download a file
 */
export const downloadSiteFile = (
  id: SiteID,
  params: DownloadSiteFileParams,
  signal?: AbortSignal
) => {
  return customFetch<Blob>({
    url: `/v1/sites/${id}/files/download`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getDownloadSiteFileQueryKey = (id?: SiteID, params?: DownloadSiteFileParams) => {
  return [`/v1/sites/${id}/files/download`, ...(params ? [params] : [])] as const;
};

export const getDownloadSiteFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadSiteFileQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSiteFile>>> = ({ signal }) =>
    downloadSiteFile(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/files/download`,
      operationId: 'app.controllers.files_controller.download_site_file',
      operationName: 'downloadSiteFile',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof downloadSiteFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSiteFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadSiteFile>>>;
export type DownloadSiteFileQueryError = Error;

export function useDownloadSiteFile<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSiteFile>>,
          TError,
          Awaited<ReturnType<typeof downloadSiteFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteFile<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSiteFile>>,
          TError,
          Awaited<ReturnType<typeof downloadSiteFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteFile<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download a file
 */

export function useDownloadSiteFile<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadSiteFileQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDownloadSiteFileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadSiteFileQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSiteFile>>> = ({ signal }) =>
    downloadSiteFile(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/files/download`,
      operationId: 'app.controllers.files_controller.download_site_file',
      operationName: 'downloadSiteFile',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadSiteFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSiteFileSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSiteFile>>
>;
export type DownloadSiteFileSuspenseQueryError = Error;

export function useDownloadSiteFileSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteFileSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteFileSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download a file
 */

export function useDownloadSiteFileSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: DownloadSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadSiteFileSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Unpacks a compressed archive (for example, .zip or .tar.gz) on the server into the specified destination folder. Returns the extraction path.
 * @summary Extract an archive
 */
export const extractSiteFile = (
  id: SiteID,
  extractFileRequest: ExtractFileRequest,
  signal?: AbortSignal
) => {
  return customFetch<PathResponse>({
    url: `/v1/sites/${id}/files/extract`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: extractFileRequest,
    signal,
  });
};

export const getExtractSiteFileMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractSiteFile>>,
    TError,
    { id: SiteID; data: ExtractFileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractSiteFile>>,
  TError,
  { id: SiteID; data: ExtractFileRequest },
  TContext
> => {
  const mutationKey = ['extractSiteFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractSiteFile>>,
    { id: SiteID; data: ExtractFileRequest }
  > = props => {
    const { id, data } = props ?? {};

    return extractSiteFile(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/files/extract` },
    {
      operationId: 'app.controllers.files_controller.extract_site_file',
      operationName: 'extractSiteFile',
    }
  );

  return customOptions;
};

export type ExtractSiteFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractSiteFile>>
>;
export type ExtractSiteFileMutationBody = ExtractFileRequest;
export type ExtractSiteFileMutationError = Error;

/**
 * @summary Extract an archive
 */
export const useExtractSiteFile = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractSiteFile>>,
      TError,
      { id: SiteID; data: ExtractFileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof extractSiteFile>>,
  TError,
  { id: SiteID; data: ExtractFileRequest },
  TContext
> => {
  const mutationOptions = getExtractSiteFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new directory at the specified path with the given folder name. Returns the full path to the new folder.
 * @summary Create a new folder
 */
export const createSiteFileFolder = (
  id: SiteID,
  createFolderRequest: CreateFolderRequest,
  signal?: AbortSignal
) => {
  return customFetch<PathResponse>({
    url: `/v1/sites/${id}/files/folder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createFolderRequest,
    signal,
  });
};

export const getCreateSiteFileFolderMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteFileFolder>>,
    TError,
    { id: SiteID; data: CreateFolderRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteFileFolder>>,
  TError,
  { id: SiteID; data: CreateFolderRequest },
  TContext
> => {
  const mutationKey = ['createSiteFileFolder'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteFileFolder>>,
    { id: SiteID; data: CreateFolderRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteFileFolder(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/files/folder` },
    {
      operationId: 'app.controllers.files_controller.create_site_file_folder',
      operationName: 'createSiteFileFolder',
    }
  );

  return customOptions;
};

export type CreateSiteFileFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteFileFolder>>
>;
export type CreateSiteFileFolderMutationBody = CreateFolderRequest;
export type CreateSiteFileFolderMutationError = Error;

/**
 * @summary Create a new folder
 */
export const useCreateSiteFileFolder = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteFileFolder>>,
      TError,
      { id: SiteID; data: CreateFolderRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteFileFolder>>,
  TError,
  { id: SiteID; data: CreateFolderRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteFileFolderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns file content as plain text or base64-encoded binary, plus MIME type. Use for in-browser editing or inspection without downloading.
 * @summary Read a file's contents
 */
export const viewSiteFile = (id: SiteID, params: ViewSiteFileParams, signal?: AbortSignal) => {
  return customFetch<ViewFileResponse>({
    url: `/v1/sites/${id}/files/view`,
    method: 'GET',
    params,
    signal,
  });
};

export const getViewSiteFileQueryKey = (id?: SiteID, params?: ViewSiteFileParams) => {
  return [`/v1/sites/${id}/files/view`, ...(params ? [params] : [])] as const;
};

export const getViewSiteFileQueryOptions = <
  TData = Awaited<ReturnType<typeof viewSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getViewSiteFileQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewSiteFile>>> = ({ signal }) =>
    viewSiteFile(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/files/view`,
      operationId: 'app.controllers.files_controller.view_site_file',
      operationName: 'viewSiteFile',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof viewSiteFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ViewSiteFileQueryResult = NonNullable<Awaited<ReturnType<typeof viewSiteFile>>>;
export type ViewSiteFileQueryError = Error;

export function useViewSiteFile<TData = Awaited<ReturnType<typeof viewSiteFile>>, TError = Error>(
  id: SiteID,
  params: ViewSiteFileParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewSiteFile>>,
          TError,
          Awaited<ReturnType<typeof viewSiteFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewSiteFile<TData = Awaited<ReturnType<typeof viewSiteFile>>, TError = Error>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewSiteFile>>,
          TError,
          Awaited<ReturnType<typeof viewSiteFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewSiteFile<TData = Awaited<ReturnType<typeof viewSiteFile>>, TError = Error>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Read a file's contents
 */

export function useViewSiteFile<TData = Awaited<ReturnType<typeof viewSiteFile>>, TError = Error>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getViewSiteFileQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getViewSiteFileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof viewSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getViewSiteFileQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewSiteFile>>> = ({ signal }) =>
    viewSiteFile(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/files/view`,
      operationId: 'app.controllers.files_controller.view_site_file',
      operationName: 'viewSiteFile',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof viewSiteFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ViewSiteFileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof viewSiteFile>>>;
export type ViewSiteFileSuspenseQueryError = Error;

export function useViewSiteFileSuspense<
  TData = Awaited<ReturnType<typeof viewSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: ViewSiteFileParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewSiteFileSuspense<
  TData = Awaited<ReturnType<typeof viewSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewSiteFileSuspense<
  TData = Awaited<ReturnType<typeof viewSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Read a file's contents
 */

export function useViewSiteFileSuspense<
  TData = Awaited<ReturnType<typeof viewSiteFile>>,
  TError = Error,
>(
  id: SiteID,
  params: ViewSiteFileParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewSiteFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getViewSiteFileSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
